import React from 'react';
import { Print } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core';
import { Button } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',

      backgroundColor: 'white',
      color: 'black',
    },
    cancel: {
      marginLeft: 'auto',
      marginRight: theme.spacing(-3.25),
      marginTop: theme.spacing(2.25),
    },
    printWrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    print: {
      margin: theme.spacing(0, 2.75, 0, 0),
      color: theme.palette.greyBlue[600],
    },
    printPages: {
      marginLeft: theme.spacing(5.75),

      color: theme.palette.greyBlue[700],
      ...theme.typography.body1,
    },
    title: {
      color: theme.palette.greyBlue[700],
      ...theme.typography.h6,
    },
  };
});

export default function PrintToast({
  labelText,
  suffix,
  onCancelPrintClick = () => {},
}) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.printWrapper}>
        <Print className={classes.print} />
        <h4 className={classes.title}>Printing to a PDF in Progress</h4>
      </div>
      <p className={classes.printPages}>
        Preparing page{suffix} <span className="noTranslate">{labelText}</span>{' '}
        for printing...
      </p>
      <Button
        className={classes.cancel}
        onClick={onCancelPrintClick}
        size="small"
        variant="secondary"
      >
        Cancel
      </Button>
    </div>
  );
}
